import shortid from "shortid";
import { formatDate } from "../../../utils";
import {
  calcularValores,
  converterData,
  converterNumero,
  converterTexto,
  validarTitulo,
} from "../importar-titulos";

export class TituloReceber {
  id = null;
  linha = null;
  numeroTitulo = null;
  origem = null;
  pessoaId = null;
  pessoaNome = null;
  historico = null;
  dataLancamento = null;
  dataVencimento = null;
  meioPagamentoId = null;
  meioPagamentoDescricao = null;
  bancoCaixaId = null;
  planoFinanceiroId = null;
  planoFinanceiroDescricao = null;
  centroCustoId = null;
  centroCustoDescricao = null;
  tipo = null;
  valor = null;
  acrescimo = null;
  desconto = null;
  valorTotal = null;
  erros = {};

  constructor(linha, cadastros) {
    this.id = shortid.generate();
    this.linha = linha.linha;
    this.numeroTitulo = converterTexto(linha.numeroTitulo);
    this.origem = converterTexto(linha.origem) || "EXPORTADO";
    this.historico = converterTexto(linha.historico);
    this.dataLancamento = converterData(linha.dataLancamento);
    this.dataVencimento = converterData(linha.dataVencimento);
    Object.assign(
      this,
      calcularValores(
        converterNumero(linha.valor),
        converterNumero(linha.valorTotal),
      ),
    );
    this.setPagador(converterNumero(linha.pessoaId), cadastros.pessoas);
    this.setMeioPagamento(
      converterNumero(linha.meioPagamentoId),
      cadastros.meiosPagamento,
    );
    this.setPlanoFinanceiro(
      converterNumero(linha.planoFinanceiroId),
      cadastros.planosFinanceiros,
    );
    this.setCentroCusto(
      converterNumero(linha.centroCustoId),
      cadastros.centrosCusto,
    );
    validarTitulo(this);
  }

  setPagador(pagadorId, pessoas) {
    const pagador = pessoas.find(({ id }) => id === pagadorId);
    this.pessoaId = pagadorId;
    this.pessoaNome = pagador?.nomeRazaoSocial;
    if (!pagador) {
      this.erros.pessoaId = pagadorId
        ? "Pagador não encontrado no cadastro"
        : "Pagador não informado";
    }
  }

  setMeioPagamento(meioPagamentoId, meiosPagamento) {
    const meioPagamento = meiosPagamento.find(
      ({ id }) => id === meioPagamentoId,
    );
    this.meioPagamentoId = meioPagamentoId;
    this.meioPagamentoDescricao = meioPagamento?.descricao;
    this.bancoCaixaId = meioPagamento?.bancoCaixaId;
    this.tipo =
      meioPagamento?.nfePagamento === "fpCreditoEmLoja"
        ? "NOTA_CREDITO"
        : "TITULO_NORMAL";
    if (!meioPagamento) {
      this.erros.meioPagamentoId = meioPagamentoId
        ? "Meio de Pagamento não encontrado no cadastro"
        : "Meio de Pagamento não informado";
    }
  }

  setPlanoFinanceiro(planoFinanceiroId, planosFinanceiros) {
    const planoFinanceiro = planosFinanceiros.find(
      ({ id }) => id === planoFinanceiroId,
    );
    this.planoFinanceiroId = planoFinanceiroId;
    this.planoFinanceiroDescricao = planoFinanceiro?.descricao;
    if (planoFinanceiroId && !planoFinanceiro) {
      this.erros.planoFinanceiroId =
        "Plano Financeiro de crédito não encontrado no cadastro";
    }
  }

  setCentroCusto(centroCustoId, centrosCusto) {
    const centroCusto = centrosCusto.find(({ id }) => id === centroCustoId);
    this.centroCustoId = centroCustoId;
    this.centroCustoDescricao = centroCusto?.descricao;
    if (centroCustoId && !centroCusto) {
      this.erros.centroCustoId = "Centro de Custo não encontrado no cadastro";
    }
  }

  dadosImportacao() {
    return {
      numeroTitulo: this.numeroTitulo,
      origem: this.origem,
      pagadorId: this.pessoaId,
      historico: this.historico,
      dataLancamento: formatDate.toSend(this.dataLancamento),
      dataVencimento: formatDate.toSend(this.dataVencimento),
      meioPagamentoId: this.meioPagamentoId,
      bancoCaixaId: this.bancoCaixaId,
      planoFinanceiroId: this.planoFinanceiroId,
      centroCustoId: this.centroCustoId,
      tipo: this.tipo,
      valor: this.valor,
      acrescimo: this.acrescimo,
      desconto: this.desconto,
    };
  }
}
